module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_icons/icn-link-error-a542ff8b5867dc33214fea70f722b028.svg";